import React from 'react';
import {Field} from 'redux-form';
import FlatButton from 'material-ui/FlatButton';
import MenuPage from '../../pages/MenuPage';
import MenuItem from 'material-ui/MenuItem';
import { Grid, Row, Col } from 'react-flexbox-grid';
import {
    SelectField,
    TextField,
} from 'redux-form-material-ui'

import translate from '../../lib/i18n/translate'

import './Profile.css';

const Profile = (props) => {
    const {handleSubmit, error} = props;
    const {Profile, Name, Language, Password, ConfirmPassword, Update} = props.strings;

    return (
        <MenuPage title={Profile} onBackClick={()=>{props.history.goBack()}}>
        <div className="container">
        <form className="ProfileForm" onSubmit={handleSubmit}>
            <Grid fluid>
            
                {error && 
                    <div className="error">{error}</div>
                }

                <Row>
                    <Col xs={12} sm={6} md={4} lg={3} mdOffset={2} lgOffset={3} >
                        <Field
                            name="displayName"
                            component={TextField}
                            hintText={Name}
                            fullWidth={true}
                            floatingLabelText={Name} />
                    </Col>
                    <Col xs={12} sm={6} md={4} lg={3} >
                        <Field
                            name="language"
                            component={SelectField}
                            hintText={Language}
                            fullWidth={true}
                            floatingLabelText={Language}>
                            <MenuItem value="cz" primaryText="Čeština"/>
                            <MenuItem value="dk" primaryText="Dansk"/>
                            <MenuItem value="de" primaryText="Deutsch"/>
                            <MenuItem value="nl" primaryText="Dutch"/>
                            <MenuItem value="en" primaryText="English"/>
                            <MenuItem value="es" primaryText="Español"/>
                            <MenuItem value="fr" primaryText="Français"/>
                            <MenuItem value="it" primaryText="Italiano"/>
                            <MenuItem value="no" primaryText="Norsk"/>
                            <MenuItem value="pt" primaryText="Português"/>
                            <MenuItem value="sk" primaryText="Slovenčina"/>
                            <MenuItem value="sv" primaryText="Svenska"/>
                            <MenuItem value="fi" primaryText="Suomalainen"/>
                            <MenuItem value="tr" primaryText="Türk"/>
                        </Field>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={6} md={4} lg={3} mdOffset={2} lgOffset={3} >
                        <Field
                            name="password1"
                            component={TextField}
                            type="password"
                            hintText={Password}
                            fullWidth={true}
                            floatingLabelText={Password}/>
                    </Col>
                    <Col xs={12} sm={6} md={4} lg={3} >
                        <Field
                            name="password2"
                            component={TextField}
                            type="password"
                            hintText={ConfirmPassword}
                            fullWidth={true}
                            floatingLabelText={ConfirmPassword}/>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={6} md={4} lg={3} smOffset={6} style={{textAlign: 'right'}} >
                    <div className="ButtonWrapper">
                        <FlatButton
                            type="submit"
                            backgroundColor="#fff"
                            label={Update}
                            fullWidth={false}/>
                    </div>
                    </Col>
                </Row>
            </Grid>
        </form>
        </div>
        </MenuPage>);
};

export default translate('Profile')(Profile);




// WEBPACK FOOTER //
// ./src/components/profile/Profile.js